import React from 'react';
import styled from 'styled-components';
import { animationFixStyle } from 'components/Common';
import AbstractToggle from './AbstractToggle';

interface StyledToggleProps {
  checked?: boolean;
}

const StyledToggle = styled.input<StyledToggleProps>`
  appearance: none;
  background: ${({ checked }) => (checked ? 'var(--sys-color--primary)' : 'var(--sys-color--surface-container-highest)')};
  border: 2px solid ${({ checked }) => (checked ? 'var(--sys-color--primary)' : 'var(--sys-color--outline)')};
  border-radius: 100px;
  box-sizing: border-box;
  cursor: pointer;
  height: 32px;
  margin: 0;
  outline: none;
  padding: 0;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 52px;
  z-index: 0;
  -webkit-tap-highlight-color: transparent;
  ${animationFixStyle}
  &:after {
    background: ${({ checked }) => (checked ? 'var(--sys-color--on-primary)' : 'var(--sys-color--outline)')};
    border-radius: 50%;
    content: ' ';
    height: ${({ checked }) => (checked ? '24px' : '16px')};
    left: ${({ checked }) => (checked ? '22px' : '6px')};
    position: absolute;
    top: ${({ checked }) => (checked ? '2px' : '6px')};
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    width: ${({ checked }) => (checked ? '24px' : '16px')};
    z-index: 2;
    ${animationFixStyle}
  }
`;

export class Slider extends AbstractToggle {
  render() {
    return (
      <StyledToggle
        id={this.props.id}
        aria-label={this.props.id}
        type="checkbox"
        checked={this.props.checked}
        onChange={this.onChange}
      />
    );
  }
}
